export const SAVE_FIELDS = "SAVE_FIELDS";
